module.exports = ".mat-slider-horizontal {\r\n  width: 500px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/a0107-progress/progress.component.css
// module id = ./src/app/a0107-progress/progress.component.css
// module chunks = main